import React from 'react';
import TiltedCard from './TiltedCard';

const WhyAlpha = () => {
  const benefits = [
    {
      imageSrc: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=400&fit=crop",
      title: "Certified Experts",
      description: "Our team consists of certified auditors with combined experience in various industries."
    },
    {
      imageSrc: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=400&fit=crop",
      title: "Confidential & Reliable",
      description: "We adhere to the strictest standards of data privacy and confidentiality for your peace of mind."
    },
    {
      imageSrc: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=400&fit=crop",
      title: "Timely Delivery",
      description: "We understand deadlines. Our streamlined process ensures accurate reports delivered on schedule."
    },
    {
      imageSrc: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&h=400&fit=crop",
      title: "Client-Centric",
      description: "We don't just audit; we partner with you to improve your financial health and operational efficiency."
    }
  ];

  return (
    <section id="why-alpha" className="py-12 md:py-20 bg-slate-50 min-h-[600px] md:min-h-[700px]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Why Choose Alpha?</h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            We combine technical expertise with a deep understanding of business operations to deliver audits that add value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex flex-col items-center h-full">
              <div className="w-full h-[250px] md:h-[300px] lg:h-[320px]">
                <TiltedCard
                  imageSrc={benefit.imageSrc}
                  alt={benefit.title}
                  captionText={benefit.title}
                  containerHeight="100%"
                  containerWidth="100%"
                  imageHeight="100%"
                  imageWidth="100%"
                  rotateAmplitude={12}
                  scaleOnHover={1.1}
                  showMobileWarning={false}
                  showTooltip={false}
                  displayOverlayContent={true}
                  overlayContent={
                    <div className="text-center p-4 w-full">
                      <div className="inline-block bg-primary/50 rounded-lg px-4 py-2 mb-3">
                        <h3 className="text-xl font-bold text-white">{benefit.title}</h3>
                      </div>
                      <p className="text-sm text-white/90">{benefit.description}</p>
                    </div>
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAlpha;
